/**
 * Load more card elements and hide Button if all are visible
 * @type {Element}
 */

const loadMoreCardsTrigger = document.querySelector('.c-tiles-loadmore');
if (loadMoreCardsTrigger) {
  const cardElements = document.querySelectorAll('.c-tile--card');
  let loadMoreIndex = 1; // Since at start three cards are displayed
  const DISPLAYCARDS = 3;
  const { cardsLength: CARDSLENGTH } = loadMoreCardsTrigger.dataset;

  loadMoreCardsTrigger.addEventListener('click', e => {
    const NEXTCARDGROUP = Array.from(cardElements).slice(
      DISPLAYCARDS * loadMoreIndex,
      DISPLAYCARDS * loadMoreIndex + DISPLAYCARDS,
    );

    loadMoreIndex += 1;
    NEXTCARDGROUP.forEach(tile => tile.classList.remove('c-tile--card-hidden'));

    if (loadMoreIndex * DISPLAYCARDS >= CARDSLENGTH) {
      e.target.remove();
    }
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/loadMoreCards.js